const createOrderInfo = (order, t) => {
  if (!order) return '';
  
  let content = [];
  
  if (order.order_type === 'delivery' && order.delivery_info) {
    content.push(`
      <div style="border: 1px dashed #000; margin: 2mm 0; padding: 2mm;">
        <div>
          <span>${t('cashier.receipt.delivery.customerName')}:</span>
          <span>${order.delivery_info.customer_name}</span>
        </div>
        <div>
          <span>${t('cashier.receipt.delivery.customerPhone')}:</span>
          <span>${order.delivery_info.customer_phone}</span>
        </div>
        <div>
          <span>${t('cashier.receipt.delivery.deliveryAddress')}:</span>
          <span>${order.delivery_info.address}</span>
        </div>
      </div>
    `);
  }
  
  if (order.table_number) {
    content.push(`
      <div style="text-align: center; margin: 2mm 0;">
        ${t('cashier.receipt.tableNumber')}: ${order.table_number}
      </div>
    `);
  }
  
  return content.join('');
};

export default createOrderInfo;
